<template>
  <form-element
    :class="{
      'select--touched': inputValue,
      'select--invalid': !isEmpty(errors),
    }"
    class="select"
    v-bind="$props"
  >
    <select
      :disabled="disabled"
      :name="name"
      class="select__input"
      @change="$emit('input', $event.target.value)"
    >
      <option v-if="!hideEmpty" value=""></option>
      <option
        v-for="option in options"
        :key="option[displayValue]"
        :value="option[displayValue]"
        :disabled="option.disabled || false"
        :selected="option[displayValue] === inputValue"
      >
        {{ option[displayKey] }}
      </option>
    </select>
    <div class="select_label">
      <span class="select_label__title">{{ localizedTitle }}</span>
      <span v-if="hasBar" class="select_label__bar" />
    </div>
  </form-element>
</template>

<script>
import { isEmpty } from 'lodash'

import FormElement from '../FormElement'

export default {
  name: 'DropDown',

  components: {
    FormElement,
  },

  props: {
    value: {
      type: [String, Object, Number, Boolean],
      default: '',
    },

    titleLabel: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      default: '',
    },

    hideEmpty: Boolean,
    disabled: Boolean,
    required: Boolean,

    hasBar: {
      type: Boolean,
      default: true,
    },

    options: {
      type: Array,
      required: true,
    },

    errors: {
      type: Object,
      default: () => ({}),
    },

    displayKey: {
      type: String,
      default: 'name',
    },

    displayValue: {
      type: String,
      default: 'value',
    },

    tooltipContent: {
      type: String,
      default: '',
    },

    tooltipLabel: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isInvalid: this.invalid,
      inputValue: this.value,
    }
  },

  computed: {
    localizedTitle() {
      return `${this.titleLabel}${this.required ? ' *' : ''}`
    },
  },

  watch: {
    value(value) {
      this.inputValue = value
    },
  },

  mounted() {
    if (!this.inputValue && this.hideEmpty) {
      this.inputValue =
        this.options.length > 0 && this.options[0][this.displayKey]
    }
  },

  methods: {
    isEmpty,
  },
}
</script>

<style scoped>
.select {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  &--touched {
    .select {
      &__input {
        font-size: 16px;
      }

      &_label__title {
        top: 0;
        z-index: 0;
        font-size: 12px;
      }
    }
  }

  &--invalid {
    .select {
      &_label__title {
        color: var(--c-secondary-color-1);
      }

      &__input {
        border-bottom-color: var(--c-secondary-color-1);
      }
    }
  }
}

.select__input {
  position: relative;
  width: 100%;
  margin-top: 15px;
  border: none;
  outline: none;
  height: 40px;
  color: var(--c-primary-neutral-1);
  border-bottom: 1px solid var(--c-primary-neutral-1);
  /** Mobile devices will zoom form fields slightly if the text is set to less than 16 pixels (mostly IPhones) */
  font-size: 16px;
  background: transparent;

  &:focus {
    font-size: 18px;

    & ~ .select_label .select_label__bar {
      width: 100%;
    }
  }

  &:disabled {
    color: var(--c-secondary-neutral-2);
  }
}

.select_label__title {
  position: absolute;
  top: 27px;
  font-size: 16px;
  color: var(--c-primary-neutral-1);
  transition: all 0.25s ease;
}

.select_label__bar {
  position: absolute;
  height: 3px;
  width: 0;
  bottom: 10px;
  background-color: var(--c-secondary-neutral-1);
  transition: all 0.3s ease;
}

@media (--md) {
  .select--touched .select__input {
    font-size: 18px;
  }
}
</style>
